import React from "react";
import { ThemeProvider } from "styled-components";
import { useLocation } from "react-router-dom";
import {
  UserSettings,
  UserSettingsProvider,
  UserSettingsConsumer
} from "./Contexts/UserSettings";
import localforage from "localforage";

import { AuthProvider } from "../Auth/AuthContext";
import { ServiceWorkerProvider } from "./ServiceWorkerContext";
import Footer from "../Footer/Footer";
import SiteHeader from "./SiteHeader/SiteHeader";
import SiteDrawer from "./SiteDrawer";
import { SiteConfigProvider } from "./Contexts/SiteConfig";
import theme from "../../utils/theme";
import getParallelsFromQuerystring from "../../utils/getParallelsFromQuerystring";
import { Site } from "../../api/typedefs/Site";
import { GlobalStyles } from "./GlobalStyles";

interface SiteWraperProps {
  site: Site;
}

const SiteWraper: React.FC<SiteWraperProps> = ({ children, site }) => {
  const location = useLocation();
  const hasParallels = getParallelsFromQuerystring(location.search) > 0;

  return (
    <ServiceWorkerProvider>
      <SiteConfigProvider site={site}>
        <AuthProvider site={site}>
          <UserSettingsProvider store={localforage}>
            <UserSettingsConsumer>
              {({ darkMode }: UserSettings) => {
                const siteTheme = theme({ site, darkMode }) as any;
                return (
                  <ThemeProvider theme={siteTheme}>
                    <>
                      <GlobalStyles />
                      <SiteDrawer theme={siteTheme} />
                      <SiteHeader hasParallels={hasParallels} />
                      {children}
                      <Footer hasParallels={hasParallels} />
                    </>
                  </ThemeProvider>
                );
              }}
            </UserSettingsConsumer>
          </UserSettingsProvider>
        </AuthProvider>
      </SiteConfigProvider>
    </ServiceWorkerProvider>
  );
};

export default SiteWraper;
